module.exports = __webpack_public_path__ + "static/media/r0gMungo.f9c5eba3.png";